import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './SectionHelper.module.scss';
export const SectionHelper = (param)=>{
    let { children, className } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.root, className),
        children: children
    });
};
